import create from "zustand";
import { devtools } from "zustand/middleware";

let contextStore = (set) => ({
  username : "",
  stationTimezone : null,
  setUsername : (username) => {
    set((state) => ({ username }));
  },
  setStationTimezone : (stationTimezone) => {
    set((state) => ({ stationTimezone }));
  }
});

contextStore = devtools(contextStore);

const useContextStore = create(contextStore);

export default useContextStore;



// WEBPACK FOOTER //
// ./src/stores/ContextStore.js